// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emp-dash-wrapper {
    min-height: 100vh;
    background: #f8fafc;
    font-family: inherit;
}

.center-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.small-spinner {
    width: 24px;
    height: 24px;
    border-width: 3px;
    margin: 1rem auto;
}

/* Header */
.emp-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 2rem;
    background: white;
    border-bottom: 1px solid #e2e8f0;
    position: sticky;
    top: 0;
    z-index: 10;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.datetime-display {
    color: #64748b;
    font-weight: 600;
    font-size: 0.95rem;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.user-profile-section {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.welcome-text {
    font-weight: 600;
    color: #1e293b;
}

.icon-btn {
    background: none;
    border: none;
    color: #64748b;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 50%;
    transition: 0.2s;
}

.icon-btn:hover {
    background: #f1f5f9;
    color: #1e293b;
}

.logout-btn:hover {
    background: #fef2f2;
    color: #dc2626;
}

/* Main Content */
.emp-main-content {
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
}

/* Stat Cards - NEW STACKED DESIGN */
.emp-stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
    margin-bottom: 2rem;
}

.emp-stat-card {
    background: white;
    padding: 1.15rem;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.border-red {
    border-bottom: 3px solid #ef4444;
}

.border-emerald {
    border-bottom: 3px solid #10b981;
}

.border-blue {
    border-bottom: 4px solid #3b82f6;
}

.border-slate {
    border-bottom: 3px solid #64748b;
}

.stat-top {
    display: flex;
    align-items: center;
    gap: 0.65rem;
}

.stat-icon {
    height: 38px;
    width: 38px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.stat-svg {
    width: 20px;
    height: 20px;
}

.bg-red-light {
    background: #fef2f2;
}

.text-red {
    color: #dc2626;
}

.bg-emerald-light {
    background: #ecfdf5;
}

.text-emerald {
    color: #059669;
}

.bg-blue-light {
    background: #eff6ff;
}

.text-blue {
    color: #2563eb;
}

.bg-slate-light {
    background: #f1f5f9;
}

.text-slate {
    color: #475569;
}

.stat-top p {
    margin: 0;
    color: #64748b;
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 1.2;
}

.stat-bottom h3 {
    margin: 0;
    font-size: 1.4rem;
    font-weight: 800;
    word-break: break-word;
    /* Prevents overflow if amount gets too large */
}

/* Filter Bar */
.emp-filter-bar {
    background: white;
    padding: 1rem 1.5rem;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 2rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

/* Lists Grid */
.emp-lists-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
    margin-bottom: 2rem;
}

.emp-list-container {
    background: white;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
}

.list-header {
    padding: 1.25rem;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.list-header h3 {
    margin: 0;
    font-size: 1.2rem;
    color: #1e293b;
}

.badge-count {
    padding: 0.25rem 0.75rem;
    border-radius: 99px;
    font-weight: 700;
    font-size: 0.85rem;
}

.list-body {
    padding: 1rem;
    height: 380px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.empty-text {
    text-align: center;
    color: #94a3b8;
    margin-top: 2rem;
    font-style: italic;
}

/* === COMPACT LIST DESIGN === */
.compact-task-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.6rem 0.85rem;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    transition: all 0.2s ease;
}

.compact-task-row:hover {
    border-color: #cbd5e1;
    background: white;
}

.payout-row {
    background: #f0fdf4;
    border-color: #bbf7d0;
}

.payout-row:hover {
    background: #dcfce7;
    border-color: #86efac;
}

.task-info-compact {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    min-width: 0;
    margin-right: 0.5rem;
}

.member-name-compact {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.task-meta-compact {
    font-size: 0.8rem;
    font-weight: 600;
}

/* Compact Buttons */
.compact-action-btn {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.4rem 0.65rem;
    border-radius: 6px;
    font-weight: 700;
    font-size: 0.8rem;
    cursor: pointer;
    transition: 0.2s ease;
    white-space: nowrap;
}

.compact-btn-initiate {
    background: #eff6ff;
    color: #2563eb;
    border: 1px solid #bfdbfe;
}

.compact-btn-initiate:hover {
    background: #dbeafe;
}

.compact-btn-payout {
    background: #ecfdf5;
    color: #059669;
    border: 1px solid #a7f3d0;
}

.compact-btn-payout:hover {
    background: #d1fae5;
}

.compact-btn-waiting {
    background: #f1f5f9;
    color: #64748b;
    border: 1px solid #cbd5e1;
    cursor: not-allowed;
}

/* History Table */
.emp-history-section {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
}

.emp-history-section h3 {
    margin: 0 0 1.25rem 0;
    font-size: 1.2rem;
    color: #1e293b;
}

.table-responsive {
    overflow-x: auto;
}

.emp-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
}

.emp-table th {
    padding: 1rem;
    background: #f8fafc;
    color: #64748b;
    font-weight: 600;
    font-size: 0.9rem;
    text-transform: uppercase;
    border-bottom: 2px solid #e2e8f0;
}

.emp-table td {
    padding: 1rem;
    border-bottom: 1px solid #f1f5f9;
    color: #334155;
    font-size: 0.95rem;
}

.type-badge {
    padding: 0.25rem 0.6rem;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 700;
}

.status-badge {
    padding: 0.25rem 0.6rem;
    border-radius: 99px;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
}

.text-yellow {
    color: #b45309;
}

.bg-yellow-light {
    background: #fef3c7;
}

/* Modals */
.emp-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    backdrop-filter: blur(4px);
}

.emp-modal-card {
    background: white;
    padding: 2.5rem;
    border-radius: 16px;
    width: 450px;
    max-width: 90vw;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.emp-modal-card h3 {
    margin: 0 0 0.5rem 0;
    color: #1e293b;
    font-size: 1.4rem;
}

.modal-info-box {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 1rem;
}

.modal-info-box p {
    margin: 0 0 0.5rem 0;
    color: #475569;
}

.modal-info-box p:last-child {
    margin: 0;
}

.modal-info-box strong {
    color: #1e293b;
}

.emp-select-input {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 2px solid #cbd5e1;
    border-radius: 10px;
    font-size: 1rem;
    outline: none;
    background: white;
    color: #1e293b;
    font-family: inherit;
}

.emp-select-input:focus {
    border-color: #3b82f6;
}

.modal-actions {
    display: flex;
    gap: 1rem;
}

.emp-btn-secondary {
    flex: 1 1;
    background: #f1f5f9;
    border: 1px solid #cbd5e1;
    color: #475569;
    padding: 0.85rem;
    border-radius: 10px;
    font-weight: 700;
    cursor: pointer;
    transition: 0.2s;
}

.emp-btn-secondary:hover {
    background: #e2e8f0;
    color: #1e293b;
}

.emp-btn-primary {
    flex: 1 1;
    background: #2563eb;
    border: none;
    color: white;
    padding: 0.85rem;
    border-radius: 10px;
    font-weight: 700;
    cursor: pointer;
    transition: 0.2s;
}

.emp-btn-primary:hover {
    background: #1d4ed8;
}

.emp-btn-primary:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* === CASH MANAGEMENT HUB BANNER === */
.emp-wallet-banner {
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid #bfdbfe;
    border-radius: 16px;
    padding: 1.5rem 2rem;
    margin-bottom: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
    transition: all 0.2s ease;
}

.emp-wallet-banner:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.15);
    border-color: #93c5fd;
}

.wallet-banner-left {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.wallet-banner-icon {
    background: #eff6ff;
    padding: 1rem;
    border-radius: 12px;
    color: #3b82f6;
    display: flex;
    align-items: center;
    justify-content: center;
}

.wallet-banner-info h2 {
    margin: 0 0 0.25rem 0;
    font-size: 1.5rem;
    font-weight: 800;
    color: #1e293b;
}

.wallet-banner-info p {
    margin: 0;
    color: #64748b;
    font-size: 1rem;
}

.wallet-banner-btn {
    background: #3b82f6;
    color: white;
    border: none;
    padding: 0.85rem 1.5rem;
    border-radius: 10px;
    font-weight: 700;
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: background 0.2s;
    white-space: nowrap;
}

.wallet-banner-btn:hover {
    background: #2563eb;
}

/* === CUSTOM DROPDOWN === */
.custom-dropdown-container {
    position: relative;
}

.custom-dropdown-trigger {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 2px solid #cbd5e1;
    border-radius: 10px;
    background: white;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s ease;
    -webkit-user-select: none;
            user-select: none;
}

.filter-trigger {
    padding: 0.6rem 1rem;
    border: 1px solid #e2e8f0;
}

.custom-dropdown-trigger:hover {
    border-color: #94a3b8;
}

.custom-dropdown-trigger.open {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.placeholder-text {
    color: #94a3b8;
    font-size: 0.95rem;
    font-weight: 500;
}

.dropdown-arrow {
    color: #64748b;
    transition: transform 0.3s ease;
}

.dropdown-arrow.rotated {
    transform: rotate(180deg);
}

.selected-emp-display {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.selected-emp-name {
    font-size: 1rem;
    color: #1e293b;
    font-weight: 600;
}

.custom-dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    max-height: 250px;
    overflow-y: auto;
    z-index: 50;
    animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-5px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.custom-dropdown-item {
    padding: 0.75rem 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    cursor: pointer;
    border-bottom: 1px solid #f1f5f9;
    transition: background 0.2s ease;
}

.custom-dropdown-item:last-child {
    border-bottom: none;
}

.custom-dropdown-item:hover {
    background: #f8fafc;
}

.custom-dropdown-item.selected {
    background: #eff6ff;
}

.emp-drop-info h4 {
    margin: 0;
    font-size: 0.95rem;
    color: #1e293b;
}

.emp-drop-info span {
    font-size: 0.8rem;
    color: #64748b;
}

.dropdown-empty {
    padding: 1.5rem;
    text-align: center;
    color: #94a3b8;
    font-style: italic;
}

/* === RESPONSIVE LAYOUT EXPERT TWEAKS === */
@media (max-width: 1024px) {
    .emp-stats-grid {
        grid-template-columns: 1fr 1fr;
    }
}

@media (max-width: 768px) {
    .emp-header {
        flex-direction: column;
        gap: 1rem;
        padding: 1.25rem;
    }

    /* Perfect adjustments for iPhone 14 Pro Max & similar */
    .emp-stats-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 0.65rem;
    }

    .emp-stat-card {
        padding: 0.85rem;
        gap: 0.6rem;
    }

    .stat-icon {
        height: 32px;
        width: 32px;
    }

    .stat-svg {
        width: 16px;
        height: 16px;
    }

    .stat-top p {
        font-size: 0.75rem;
    }

    .stat-bottom h3 {
        font-size: 1.25rem;
    }

    .emp-filter-bar {
        flex-direction: row;
        align-items: center;
    }

    .custom-dropdown-container {
        width: 100% !important;
        margin-left: 0 !important;
        flex: 1 1;
    }

    .emp-lists-grid {
        grid-template-columns: 1fr;
    }

    .emp-main-content {
        padding: 1rem;
    }

    .emp-modal-card {
        padding: 1.5rem;
    }

    .compact-task-row {
        flex-direction: row;
        align-items: center;
    }

    .emp-wallet-banner {
        flex-direction: column;
        align-items: flex-start;
        padding: 1.25rem;
        gap: 1.25rem;
    }

    .wallet-banner-left {
        width: 100%;
        gap: 1rem;
    }

    .wallet-banner-info h2 {
        font-size: 1.25rem;
    }

    .wallet-banner-info p {
        font-size: 0.9rem;
    }

    .wallet-banner-btn {
        width: 100%;
        justify-content: center;
    }
}

/* === NOTIFICATION MODAL STYLES === */
.notification-wrapper {
    position: relative;
}

.notification-btn {
    position: relative;
}

.badge {
    position: absolute;
    top: -2px;
    right: -2px;
    background: #ef4444;
    color: white;
    font-size: 0.7rem;
    font-weight: bold;
    height: 18px;
    min-width: 18px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
}

.notification-modal {
    position: absolute;
    top: 50px;
    right: 0;
    width: 320px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
    border: 1px solid #e2e8f0;
    overflow: hidden;
    z-index: 1000;
    transform-origin: top right;
    animation: dropDown 0.2s ease-out forwards;
}

.notification-modal.expanded {
    width: 400px;
}

@keyframes dropDown {
    from {
        opacity: 0;
        transform: scale(0.95);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

.notif-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #f1f5f9;
    background: #f8fafc;
}

.notif-header h4 {
    margin: 0;
    font-size: 1rem;
    color: #1e293b;
}

.notif-count {
    font-size: 0.75rem;
    background: #fee2e2;
    color: #ef4444;
    padding: 0.2rem 0.6rem;
    border-radius: 99px;
    font-weight: 700;
}

.notif-body {
    max-height: 350px;
    overflow-y: auto;
}

.expanded-body {
    max-height: 500px;
}

.notif-empty {
    padding: 2rem;
    text-align: center;
    color: #94a3b8;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
}

.empty-bell {
    opacity: 0.3;
    margin-bottom: 0.5rem;
}

.notif-empty p {
    margin: 0;
    font-size: 0.95rem;
}

.notif-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.notif-item {
    display: flex;
    gap: 1rem;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #f1f5f9;
    transition: background 0.2s;
}

.notif-item:hover {
    background: #f8fafc;
}

.notif-item.unread {
    background: #eff6ff;
}

.notif-item.unread:hover {
    background: #e0e7ff;
}

.notif-icon {
    background: #e2e8f0;
    height: 36px;
    width: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #475569;
    flex-shrink: 0;
}

.unread .notif-icon {
    background: #3b82f6;
    color: white;
}

.notif-content {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.notif-title {
    margin: 0;
    font-size: 0.95rem;
    color: #1e293b;
    font-weight: 600;
}

.notif-desc {
    margin: 0;
    font-size: 0.85rem;
    color: #64748b;
    line-height: 1.4;
}

.notif-time {
    font-size: 0.75rem;
    color: #94a3b8;
    margin-top: 0.25rem;
}

.notif-footer {
    padding: 0.75rem;
    text-align: center;
    background: #f8fafc;
    border-top: 1px solid #f1f5f9;
    font-size: 0.9rem;
    font-weight: 600;
    color: #2563eb;
    cursor: pointer;
    transition: background 0.2s;
}

.notif-footer:hover {
    background: #f1f5f9;
    color: #1d4ed8;
}

.notif-pagination-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 1.25rem;
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
}

.page-btn {
    background: white;
    border: 1px solid #cbd5e1;
    color: #475569;
    padding: 0.4rem 0.75rem;
    border-radius: 6px;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
    background: #f1f5f9;
    color: #1e293b;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.page-info {
    font-size: 0.85rem;
    color: #64748b;
    font-weight: 500;
}

@media (max-width: 768px) {
    .notification-modal {
        position: fixed;
        top: 60px;
        left: 5%;
        width: 90%;
        transform-origin: top center;
    }

    .notification-modal.expanded {
        width: 90%;
    }
}

/* === DIALOG MODAL STYLES === */
.confirm-dialog-card {
    text-align: center;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2.5rem 2rem;
}

.confirm-icon-wrapper {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.25rem;
}

.confirm-dialog-card h3 {
    margin: 0 0 0.75rem 0;
    font-size: 1.4rem;
    color: #1e293b;
    font-weight: 800;
}

.confirm-dialog-card p {
    margin: 0;
    color: #64748b;
    line-height: 1.5;
    font-size: 1.05rem;
}

.btn-success-fill {
    background: #10b981 !important;
    color: white !important;
}

.btn-success-fill:hover:not(:disabled) {
    background: #059669 !important;
}

@media (max-width: 768px) {
    .confirm-dialog-card {
        padding: 2rem 1.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/employee/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,+CAA+C;AACnD;;AAEA,eAAe;AACf;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA,eAAe;AACf;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,+CAA+C;AACnD;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,uCAAuC;AACvC;IACI,6DAA6D;IAC7D,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,kFAAkF;IAClF,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,qDAAqD;IACrD,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,+CAA+C;IAC/C,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA,4CAA4C;AAC5C;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;QACT,gBAAgB;IACpB;;IAEA,wDAAwD;IACxD;QACI,qCAAqC;QACrC,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,yBAAyB;QACzB,SAAO;IACX;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ;;AAEA,sCAAsC;AACtC;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,mFAAmF;IACnF,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;QACV,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;QACf,SAAS;QACT,QAAQ;QACR,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ","sourcesContent":[".emp-dash-wrapper {\n    min-height: 100vh;\n    background: #f8fafc;\n    font-family: inherit;\n}\n\n.center-content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.small-spinner {\n    width: 24px;\n    height: 24px;\n    border-width: 3px;\n    margin: 1rem auto;\n}\n\n/* Header */\n.emp-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 2rem;\n    background: white;\n    border-bottom: 1px solid #e2e8f0;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n.datetime-display {\n    color: #64748b;\n    font-weight: 600;\n    font-size: 0.95rem;\n}\n\n.header-right {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n}\n\n.user-profile-section {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.welcome-text {\n    font-weight: 600;\n    color: #1e293b;\n}\n\n.icon-btn {\n    background: none;\n    border: none;\n    color: #64748b;\n    cursor: pointer;\n    padding: 0.5rem;\n    border-radius: 50%;\n    transition: 0.2s;\n}\n\n.icon-btn:hover {\n    background: #f1f5f9;\n    color: #1e293b;\n}\n\n.logout-btn:hover {\n    background: #fef2f2;\n    color: #dc2626;\n}\n\n/* Main Content */\n.emp-main-content {\n    padding: 2rem;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n/* Stat Cards - NEW STACKED DESIGN */\n.emp-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1rem;\n    margin-bottom: 2rem;\n}\n\n.emp-stat-card {\n    background: white;\n    padding: 1.15rem;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.85rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n.border-red {\n    border-bottom: 3px solid #ef4444;\n}\n\n.border-emerald {\n    border-bottom: 3px solid #10b981;\n}\n\n.border-blue {\n    border-bottom: 4px solid #3b82f6;\n}\n\n.border-slate {\n    border-bottom: 3px solid #64748b;\n}\n\n.stat-top {\n    display: flex;\n    align-items: center;\n    gap: 0.65rem;\n}\n\n.stat-icon {\n    height: 38px;\n    width: 38px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.stat-svg {\n    width: 20px;\n    height: 20px;\n}\n\n.bg-red-light {\n    background: #fef2f2;\n}\n\n.text-red {\n    color: #dc2626;\n}\n\n.bg-emerald-light {\n    background: #ecfdf5;\n}\n\n.text-emerald {\n    color: #059669;\n}\n\n.bg-blue-light {\n    background: #eff6ff;\n}\n\n.text-blue {\n    color: #2563eb;\n}\n\n.bg-slate-light {\n    background: #f1f5f9;\n}\n\n.text-slate {\n    color: #475569;\n}\n\n.stat-top p {\n    margin: 0;\n    color: #64748b;\n    font-size: 0.8rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    line-height: 1.2;\n}\n\n.stat-bottom h3 {\n    margin: 0;\n    font-size: 1.4rem;\n    font-weight: 800;\n    word-break: break-word;\n    /* Prevents overflow if amount gets too large */\n}\n\n/* Filter Bar */\n.emp-filter-bar {\n    background: white;\n    padding: 1rem 1.5rem;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 2rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n/* Lists Grid */\n.emp-lists-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 2rem;\n    margin-bottom: 2rem;\n}\n\n.emp-list-container {\n    background: white;\n    border-radius: 16px;\n    border: 1px solid #e2e8f0;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n}\n\n.list-header {\n    padding: 1.25rem;\n    border-bottom: 1px solid #f1f5f9;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.list-header h3 {\n    margin: 0;\n    font-size: 1.2rem;\n    color: #1e293b;\n}\n\n.badge-count {\n    padding: 0.25rem 0.75rem;\n    border-radius: 99px;\n    font-weight: 700;\n    font-size: 0.85rem;\n}\n\n.list-body {\n    padding: 1rem;\n    height: 380px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.empty-text {\n    text-align: center;\n    color: #94a3b8;\n    margin-top: 2rem;\n    font-style: italic;\n}\n\n/* === COMPACT LIST DESIGN === */\n.compact-task-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.6rem 0.85rem;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n}\n\n.compact-task-row:hover {\n    border-color: #cbd5e1;\n    background: white;\n}\n\n.payout-row {\n    background: #f0fdf4;\n    border-color: #bbf7d0;\n}\n\n.payout-row:hover {\n    background: #dcfce7;\n    border-color: #86efac;\n}\n\n.task-info-compact {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n    min-width: 0;\n    margin-right: 0.5rem;\n}\n\n.member-name-compact {\n    font-size: 0.95rem;\n    font-weight: 700;\n    color: #1e293b;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.task-meta-compact {\n    font-size: 0.8rem;\n    font-weight: 600;\n}\n\n/* Compact Buttons */\n.compact-action-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.35rem;\n    padding: 0.4rem 0.65rem;\n    border-radius: 6px;\n    font-weight: 700;\n    font-size: 0.8rem;\n    cursor: pointer;\n    transition: 0.2s ease;\n    white-space: nowrap;\n}\n\n.compact-btn-initiate {\n    background: #eff6ff;\n    color: #2563eb;\n    border: 1px solid #bfdbfe;\n}\n\n.compact-btn-initiate:hover {\n    background: #dbeafe;\n}\n\n.compact-btn-payout {\n    background: #ecfdf5;\n    color: #059669;\n    border: 1px solid #a7f3d0;\n}\n\n.compact-btn-payout:hover {\n    background: #d1fae5;\n}\n\n.compact-btn-waiting {\n    background: #f1f5f9;\n    color: #64748b;\n    border: 1px solid #cbd5e1;\n    cursor: not-allowed;\n}\n\n/* History Table */\n.emp-history-section {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n}\n\n.emp-history-section h3 {\n    margin: 0 0 1.25rem 0;\n    font-size: 1.2rem;\n    color: #1e293b;\n}\n\n.table-responsive {\n    overflow-x: auto;\n}\n\n.emp-table {\n    width: 100%;\n    border-collapse: collapse;\n    text-align: left;\n}\n\n.emp-table th {\n    padding: 1rem;\n    background: #f8fafc;\n    color: #64748b;\n    font-weight: 600;\n    font-size: 0.9rem;\n    text-transform: uppercase;\n    border-bottom: 2px solid #e2e8f0;\n}\n\n.emp-table td {\n    padding: 1rem;\n    border-bottom: 1px solid #f1f5f9;\n    color: #334155;\n    font-size: 0.95rem;\n}\n\n.type-badge {\n    padding: 0.25rem 0.6rem;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    font-weight: 700;\n}\n\n.status-badge {\n    padding: 0.25rem 0.6rem;\n    border-radius: 99px;\n    font-size: 0.75rem;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n\n.text-yellow {\n    color: #b45309;\n}\n\n.bg-yellow-light {\n    background: #fef3c7;\n}\n\n/* Modals */\n.emp-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 100;\n    backdrop-filter: blur(4px);\n}\n\n.emp-modal-card {\n    background: white;\n    padding: 2.5rem;\n    border-radius: 16px;\n    width: 450px;\n    max-width: 90vw;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n}\n\n.emp-modal-card h3 {\n    margin: 0 0 0.5rem 0;\n    color: #1e293b;\n    font-size: 1.4rem;\n}\n\n.modal-info-box {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    padding: 1rem;\n}\n\n.modal-info-box p {\n    margin: 0 0 0.5rem 0;\n    color: #475569;\n}\n\n.modal-info-box p:last-child {\n    margin: 0;\n}\n\n.modal-info-box strong {\n    color: #1e293b;\n}\n\n.emp-select-input {\n    width: 100%;\n    padding: 0.75rem 1rem;\n    border: 2px solid #cbd5e1;\n    border-radius: 10px;\n    font-size: 1rem;\n    outline: none;\n    background: white;\n    color: #1e293b;\n    font-family: inherit;\n}\n\n.emp-select-input:focus {\n    border-color: #3b82f6;\n}\n\n.modal-actions {\n    display: flex;\n    gap: 1rem;\n}\n\n.emp-btn-secondary {\n    flex: 1;\n    background: #f1f5f9;\n    border: 1px solid #cbd5e1;\n    color: #475569;\n    padding: 0.85rem;\n    border-radius: 10px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: 0.2s;\n}\n\n.emp-btn-secondary:hover {\n    background: #e2e8f0;\n    color: #1e293b;\n}\n\n.emp-btn-primary {\n    flex: 1;\n    background: #2563eb;\n    border: none;\n    color: white;\n    padding: 0.85rem;\n    border-radius: 10px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: 0.2s;\n}\n\n.emp-btn-primary:hover {\n    background: #1d4ed8;\n}\n\n.emp-btn-primary:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n/* === CASH MANAGEMENT HUB BANNER === */\n.emp-wallet-banner {\n    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n    border: 1px solid #bfdbfe;\n    border-radius: 16px;\n    padding: 1.5rem 2rem;\n    margin-bottom: 2rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n    transition: all 0.2s ease;\n}\n\n.emp-wallet-banner:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.15);\n    border-color: #93c5fd;\n}\n\n.wallet-banner-left {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n}\n\n.wallet-banner-icon {\n    background: #eff6ff;\n    padding: 1rem;\n    border-radius: 12px;\n    color: #3b82f6;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.wallet-banner-info h2 {\n    margin: 0 0 0.25rem 0;\n    font-size: 1.5rem;\n    font-weight: 800;\n    color: #1e293b;\n}\n\n.wallet-banner-info p {\n    margin: 0;\n    color: #64748b;\n    font-size: 1rem;\n}\n\n.wallet-banner-btn {\n    background: #3b82f6;\n    color: white;\n    border: none;\n    padding: 0.85rem 1.5rem;\n    border-radius: 10px;\n    font-weight: 700;\n    font-size: 1rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    transition: background 0.2s;\n    white-space: nowrap;\n}\n\n.wallet-banner-btn:hover {\n    background: #2563eb;\n}\n\n/* === CUSTOM DROPDOWN === */\n.custom-dropdown-container {\n    position: relative;\n}\n\n.custom-dropdown-trigger {\n    width: 100%;\n    padding: 0.75rem 1rem;\n    border: 2px solid #cbd5e1;\n    border-radius: 10px;\n    background: white;\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    transition: all 0.2s ease;\n    user-select: none;\n}\n\n.filter-trigger {\n    padding: 0.6rem 1rem;\n    border: 1px solid #e2e8f0;\n}\n\n.custom-dropdown-trigger:hover {\n    border-color: #94a3b8;\n}\n\n.custom-dropdown-trigger.open {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.placeholder-text {\n    color: #94a3b8;\n    font-size: 0.95rem;\n    font-weight: 500;\n}\n\n.dropdown-arrow {\n    color: #64748b;\n    transition: transform 0.3s ease;\n}\n\n.dropdown-arrow.rotated {\n    transform: rotate(180deg);\n}\n\n.selected-emp-display {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.selected-emp-name {\n    font-size: 1rem;\n    color: #1e293b;\n    font-weight: 600;\n}\n\n.custom-dropdown-menu {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    right: 0;\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n    max-height: 250px;\n    overflow-y: auto;\n    z-index: 50;\n    animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-5px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.custom-dropdown-item {\n    padding: 0.75rem 1rem;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    cursor: pointer;\n    border-bottom: 1px solid #f1f5f9;\n    transition: background 0.2s ease;\n}\n\n.custom-dropdown-item:last-child {\n    border-bottom: none;\n}\n\n.custom-dropdown-item:hover {\n    background: #f8fafc;\n}\n\n.custom-dropdown-item.selected {\n    background: #eff6ff;\n}\n\n.emp-drop-info h4 {\n    margin: 0;\n    font-size: 0.95rem;\n    color: #1e293b;\n}\n\n.emp-drop-info span {\n    font-size: 0.8rem;\n    color: #64748b;\n}\n\n.dropdown-empty {\n    padding: 1.5rem;\n    text-align: center;\n    color: #94a3b8;\n    font-style: italic;\n}\n\n/* === RESPONSIVE LAYOUT EXPERT TWEAKS === */\n@media (max-width: 1024px) {\n    .emp-stats-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n@media (max-width: 768px) {\n    .emp-header {\n        flex-direction: column;\n        gap: 1rem;\n        padding: 1.25rem;\n    }\n\n    /* Perfect adjustments for iPhone 14 Pro Max & similar */\n    .emp-stats-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 0.65rem;\n    }\n\n    .emp-stat-card {\n        padding: 0.85rem;\n        gap: 0.6rem;\n    }\n\n    .stat-icon {\n        height: 32px;\n        width: 32px;\n    }\n\n    .stat-svg {\n        width: 16px;\n        height: 16px;\n    }\n\n    .stat-top p {\n        font-size: 0.75rem;\n    }\n\n    .stat-bottom h3 {\n        font-size: 1.25rem;\n    }\n\n    .emp-filter-bar {\n        flex-direction: row;\n        align-items: center;\n    }\n\n    .custom-dropdown-container {\n        width: 100% !important;\n        margin-left: 0 !important;\n        flex: 1;\n    }\n\n    .emp-lists-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .emp-main-content {\n        padding: 1rem;\n    }\n\n    .emp-modal-card {\n        padding: 1.5rem;\n    }\n\n    .compact-task-row {\n        flex-direction: row;\n        align-items: center;\n    }\n\n    .emp-wallet-banner {\n        flex-direction: column;\n        align-items: flex-start;\n        padding: 1.25rem;\n        gap: 1.25rem;\n    }\n\n    .wallet-banner-left {\n        width: 100%;\n        gap: 1rem;\n    }\n\n    .wallet-banner-info h2 {\n        font-size: 1.25rem;\n    }\n\n    .wallet-banner-info p {\n        font-size: 0.9rem;\n    }\n\n    .wallet-banner-btn {\n        width: 100%;\n        justify-content: center;\n    }\n}\n\n/* === NOTIFICATION MODAL STYLES === */\n.notification-wrapper {\n    position: relative;\n}\n\n.notification-btn {\n    position: relative;\n}\n\n.badge {\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    background: #ef4444;\n    color: white;\n    font-size: 0.7rem;\n    font-weight: bold;\n    height: 18px;\n    min-width: 18px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid white;\n}\n\n.notification-modal {\n    position: absolute;\n    top: 50px;\n    right: 0;\n    width: 320px;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);\n    border: 1px solid #e2e8f0;\n    overflow: hidden;\n    z-index: 1000;\n    transform-origin: top right;\n    animation: dropDown 0.2s ease-out forwards;\n}\n\n.notification-modal.expanded {\n    width: 400px;\n}\n\n@keyframes dropDown {\n    from {\n        opacity: 0;\n        transform: scale(0.95);\n    }\n\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n.notif-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 1.25rem;\n    border-bottom: 1px solid #f1f5f9;\n    background: #f8fafc;\n}\n\n.notif-header h4 {\n    margin: 0;\n    font-size: 1rem;\n    color: #1e293b;\n}\n\n.notif-count {\n    font-size: 0.75rem;\n    background: #fee2e2;\n    color: #ef4444;\n    padding: 0.2rem 0.6rem;\n    border-radius: 99px;\n    font-weight: 700;\n}\n\n.notif-body {\n    max-height: 350px;\n    overflow-y: auto;\n}\n\n.expanded-body {\n    max-height: 500px;\n}\n\n.notif-empty {\n    padding: 2rem;\n    text-align: center;\n    color: #94a3b8;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.empty-bell {\n    opacity: 0.3;\n    margin-bottom: 0.5rem;\n}\n\n.notif-empty p {\n    margin: 0;\n    font-size: 0.95rem;\n}\n\n.notif-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.notif-item {\n    display: flex;\n    gap: 1rem;\n    padding: 1rem 1.25rem;\n    border-bottom: 1px solid #f1f5f9;\n    transition: background 0.2s;\n}\n\n.notif-item:hover {\n    background: #f8fafc;\n}\n\n.notif-item.unread {\n    background: #eff6ff;\n}\n\n.notif-item.unread:hover {\n    background: #e0e7ff;\n}\n\n.notif-icon {\n    background: #e2e8f0;\n    height: 36px;\n    width: 36px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #475569;\n    flex-shrink: 0;\n}\n\n.unread .notif-icon {\n    background: #3b82f6;\n    color: white;\n}\n\n.notif-content {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.notif-title {\n    margin: 0;\n    font-size: 0.95rem;\n    color: #1e293b;\n    font-weight: 600;\n}\n\n.notif-desc {\n    margin: 0;\n    font-size: 0.85rem;\n    color: #64748b;\n    line-height: 1.4;\n}\n\n.notif-time {\n    font-size: 0.75rem;\n    color: #94a3b8;\n    margin-top: 0.25rem;\n}\n\n.notif-footer {\n    padding: 0.75rem;\n    text-align: center;\n    background: #f8fafc;\n    border-top: 1px solid #f1f5f9;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #2563eb;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.notif-footer:hover {\n    background: #f1f5f9;\n    color: #1d4ed8;\n}\n\n.notif-pagination-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.75rem 1.25rem;\n    background: #f8fafc;\n    border-top: 1px solid #e2e8f0;\n}\n\n.page-btn {\n    background: white;\n    border: 1px solid #cbd5e1;\n    color: #475569;\n    padding: 0.4rem 0.75rem;\n    border-radius: 6px;\n    font-size: 0.85rem;\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    transition: all 0.2s;\n}\n\n.page-btn:hover:not(:disabled) {\n    background: #f1f5f9;\n    color: #1e293b;\n}\n\n.page-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.page-info {\n    font-size: 0.85rem;\n    color: #64748b;\n    font-weight: 500;\n}\n\n@media (max-width: 768px) {\n    .notification-modal {\n        position: fixed;\n        top: 60px;\n        left: 5%;\n        width: 90%;\n        transform-origin: top center;\n    }\n\n    .notification-modal.expanded {\n        width: 90%;\n    }\n}\n\n/* === DIALOG MODAL STYLES === */\n.confirm-dialog-card {\n    text-align: center;\n    max-width: 400px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 2.5rem 2rem;\n}\n\n.confirm-icon-wrapper {\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1.25rem;\n}\n\n.confirm-dialog-card h3 {\n    margin: 0 0 0.75rem 0;\n    font-size: 1.4rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.confirm-dialog-card p {\n    margin: 0;\n    color: #64748b;\n    line-height: 1.5;\n    font-size: 1.05rem;\n}\n\n.btn-success-fill {\n    background: #10b981 !important;\n    color: white !important;\n}\n\n.btn-success-fill:hover:not(:disabled) {\n    background: #059669 !important;\n}\n\n@media (max-width: 768px) {\n    .confirm-dialog-card {\n        padding: 2rem 1.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
